import { QueryClient } from '@tanstack/react-query';
import { createContext } from 'react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
});

/** @internal */
export const NotificationQueryClientContext = createContext(queryClient);
